module.exports = __webpack_public_path__ + "static/before-eccc475f13273a8a4e4fa13b2f500068.png";